export const BASE_URL = "https://qlogcc-api.palmisttech.com/webapi";

// export const BASE_URL = "https://api-coldchain.we-io.com/webapi";
export const GOOGLE_MAP_KEY = "AIzaSyAmjEn7OoUoj3EPApR7SvqCWxamJJAb6ig";
